import { Link } from 'react-router-dom';

const WHATSAPP_1 = '5585994347047';
const WHATSAPP_2 = '5585992951348';

function WhatsAppIcon() {
  return (
    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
      <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.558 4.122 1.533 5.85L.057 23.535a.75.75 0 0 0 .916.928l5.803-1.524A11.938 11.938 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.853 0-3.587-.5-5.084-1.375l-.361-.214-3.742.981.998-3.648-.235-.374A9.963 9.963 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"/>
    </svg>
  );
}

function InstagramIcon() {
  return (
    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"/>
    </svg>
  );
}

function EmailIcon() {
  return (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
    </svg>
  );
}

function PinIcon() {
  return (
    <svg className="w-4 h-4 shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
  );
}

function ClockIcon() {
  return (
    <svg className="w-4 h-4 shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  );
}

export function Footer() {
  return (
    <footer className="bg-text-dark text-champagne-light mt-16">
      {/* Corpo do rodapé */}
      <div className="max-w-6xl mx-auto px-4 py-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
        {/* Coluna 1 — Marca */}
        <div className="flex flex-col gap-4">
          <div>
            <h2 className="text-2xl font-bold text-white tracking-wide">Baby Chic</h2>
            <p className="text-sm text-champagne-dark mt-1 leading-relaxed">
              Vestimos criança como criança!
            </p>
          </div>
          <a
            href={`https://www.instagram.com/babychic.sm/`}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-sm text-champagne-dark hover:text-chocolate-light transition-colors group"
          >
            <span className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center group-hover:bg-chocolate/30 transition-colors">
              <InstagramIcon />
            </span>
            @babychic.sm
          </a>
        </div>

        {/* Coluna 2 — Contato */}
        <div className="flex flex-col gap-3">
          <h3 className="text-sm font-semibold text-white uppercase tracking-widest">Contato</h3>
          <ul className="flex flex-col gap-3">
            <li>
              <a
                href={`https://wa.me/${WHATSAPP_1}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-sm text-champagne-dark hover:text-chocolate-light transition-colors"
              >
                <span className="text-success"><WhatsAppIcon /></span>
                (85) 99421-0413
              </a>
            </li>
            <li>
              <a
                href={`https://wa.me/${WHATSAPP_2}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-sm text-champagne-dark hover:text-chocolate-light transition-colors"
              >
                <span className="text-success"><WhatsAppIcon /></span>
                (85) 99295-1348
              </a>
            </li>
            <li>
              <a
                href="mailto:babychic.sm@gmail.com"
                className="flex items-center gap-2 text-sm text-champagne-dark hover:text-chocolate-light transition-colors"
              >
                <EmailIcon />
                babychic.sm@gmail.com
              </a>
            </li>
          </ul>
        </div>

        {/* Coluna 3 — Endereço */}
        <div className="flex flex-col gap-3">
          <h3 className="text-sm font-semibold text-white uppercase tracking-widest">Onde estamos</h3>
          <a
            href="https://maps.google.com/?q=Avenida+Maria+Gomes+de+Sá,+1755,+Mondubim,+Fortaleza,+CE"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-start gap-2 text-sm text-champagne-dark hover:text-chocolate-light transition-colors"
          >
            <PinIcon />
            <span>
              Av. Maria Gomes de Sá, 1755<br />
              Mondubim — Fortaleza, CE
            </span>
          </a>
          <div className="flex items-start gap-2 text-sm text-champagne-dark">
            <ClockIcon />
            <span>
              Seg–Sex: 10h às 19h<br />
              Sáb: 10h às 18h
            </span>
          </div>
        </div>

        {/* Coluna 4 — Links úteis */}
        <div className="flex flex-col gap-3">
          <h3 className="text-sm font-semibold text-white uppercase tracking-widest">Links úteis</h3>
          <ul className="flex flex-col gap-2">
            {[
              { label: 'Catálogo', href: '/' },
              { label: 'Minha conta', href: '/perfil' },
              { label: 'Meu carrinho', href: '/cart' },
              { label: 'Cadastrar', href: '/cadastro' },
            ].map(({ label, href }) => (
              <li key={href}>
                <Link
                  to={href}
                  className="text-sm text-champagne-dark hover:text-chocolate-light transition-colors"
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Divider + copyright */}
      <div className="border-t border-white/10">
        <div className="max-w-6xl mx-auto px-4 py-4 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-champagne-dark/60">
            © {new Date().getFullYear()} Baby Chic. Todos os direitos reservados.
          </p>
          <p className="text-xs text-champagne-dark/40">
            Moda infantil com amor ♡
          </p>
        </div>
      </div>
    </footer>
  );
}
